'use client';
import { useId, useState } from 'react';
import { Heading } from './Heading';
import { spacingClass } from '@/utils/spacing';

/**
 * @param {{ title?: string, items?: Array<{ image?: string, question: string, answer: string, ctaLabel?: string, ctaHref?: string }>, spacing?: string, headingLevel?: number }} props
 */
export function FaqBlock({ title, items = [], spacing = 'normal', headingLevel = 2 }) {
  const [open, setOpen] = useState(null);
  const uid = useId();
  return (
    <section className={'px-6 md:px-16 ' + spacingClass(spacing)}>
      <div className="max-w-2xl mx-auto">
        {title && <Heading level={headingLevel} className="font-heading text-h1 font-light text-theme-text mb-10">{title}</Heading>}
        <div className="flex flex-col divide-y divide-theme-border border-t border-b border-theme-border">
          {items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i}>
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  aria-controls={`${uid}-panel-${i}`}
                  className="w-full flex items-center justify-between py-5 text-left gap-4"
                >
                  <span className="flex items-center gap-3">
                    {item.image && <img src={item.image} alt={item.imageAlt || item.question || ''} className="w-9 h-9 rounded-md object-cover shrink-0" loading="lazy" decoding="async" />}
                    <span className="font-heading text-lg font-normal text-theme-text">{item.question}</span>
                  </span>
                  <span className="text-theme-text-subtle text-xl leading-none shrink-0" aria-hidden="true">{isOpen ? '−' : '+'}</span>
                </button>
                {isOpen && (
                  <div id={`${uid}-panel-${i}`} className="pb-5">
                    <p className="text-sm text-theme-text-muted leading-relaxed">{item.answer}</p>
                    {item.ctaLabel && (
                      <a href={item.ctaHref || '#'} className="inline-flex items-center text-sm text-theme-accent mt-3">
                        {item.ctaLabel}
                      </a>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
